<div class="report-container" *ngIf="showReport">
    <app-telerik-report-viewer
        [reportName]="reportFilePath"
        [parameters]="params"
    ></app-telerik-report-viewer>
</div>




// WEBPACK FOOTER //
// ./src/app/developer/reporting/report-viewer/report-viewer.component.html